// removed by extract-text-webpack-plugin
module.exports = {"panel":"_3jUv1","panel__checkbox":"_15Igv","panel__label":"vMNBw","panel__content":"_3gm1s"};


//////////////////
// WEBPACK FOOTER
// ./components/CollapsiblePanel/styles.scss
// module id = 704
// module chunks = 0